import React from 'react';
import { AlertCircle, EyeOff, Ghost, GlobeLock } from 'lucide-react';

const ProblemSection: React.FC = () => {
  const pitfalls = [
    {
      icon: <AlertCircle className="w-6 h-6 text-[#C5A059]" />,
      title: "Presentation Trust",
      desc: "Investors don’t trust your presentation because it lacks the technical rigor they expect."
    },
    {
      icon: <EyeOff className="w-6 h-6 text-[#C5A059]" />,
      title: "Buyer Verification",
      desc: "Buyers can’t verify your credibility, leading them to seek suppliers with more transparent track records."
    },
    {
      icon: <Ghost className="w-6 h-6 text-[#C5A059]" />,
      title: "Informal Perception",
      desc: "Your business looks informal, even when it isn't, causing it to be systematically undervalued."
    },
    {
      icon: <GlobeLock className="w-6 h-6 text-[#C5A059]" />,
      title: "Digital Invisibility",
      desc: "You are invisible to global procurement teams online, missing out on direct-to-buyer opportunities."
    }
  ];

  return (
    <section id="advisory" className="py-32 bg-[#010712] flex justify-center px-4 scroll-mt-32">
      <div className="w-full max-w-[1440px] px-4 md:px-8 flex flex-col gap-16">
        
        {/* Narrative Header - Level 1 Label */}
        <div className="max-w-4xl">
          <span className="text-[#C5A059] text-[10px] md:text-[11px] font-bold uppercase tracking-[0.3em] mb-6 block">
            The Critical Gap
          </span>
          <h2 className="text-3xl md:text-5xl font-bold tracking-tight leading-tight text-white mb-8">
            Most African Mines Don’t Fail Geologically. They Fail Perceptually.
          </h2>
          <div className="text-zinc-400 text-base md:text-lg leading-relaxed max-w-3xl">
            <p>
              Your operation may be viable, your resource may be proven, and your production may be stable—but without institutional-grade positioning, your value remains trapped behind a wall of skepticism and informal optics.
            </p>
          </div>
        </div>

        {/* Grid of Issues - Flat Layered Surface Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {pitfalls.map((item, idx) => (
            <div 
              key={idx} 
              className="p-10 bg-[#0a1220]/50 hover:bg-[#0a1220]/80 transition-all rounded-none shadow-none group"
            >
              <div className="w-12 h-12 flex items-center justify-center bg-[#111d30] rounded-none mb-6 transition-all group-hover:bg-[#1b2b42]">
                {item.icon}
              </div>
              <h4 className="font-bold text-[15px] uppercase tracking-widest mb-3 text-white">
                {item.title}
              </h4>
              <p className="text-sm text-zinc-400 leading-relaxed max-w-md">
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProblemSection;
